import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BookOpenCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";

// Shows matching knowledge articles while typing a ticket subject; "this solved it" records a deflection.
export function KbSuggest({ subject, onDeflect }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!subject || subject.trim().length < 4) { setRows([]); return undefined; }
    const t = setTimeout(async () => { try { const { data } = await api.get(`/it/kb/suggest?q=${encodeURIComponent(subject)}`); setRows(data.articles); } catch { setRows([]); } }, 350);
    return () => clearTimeout(t);
  }, [subject]);
  if (!rows.length) return null;
  const deflect = async (a) => { try { await api.post(`/it/kb/${a.id}/deflect`, { subject }); toast.success("Great — no ticket needed"); onDeflect(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="mt-2 border rounded-md bg-emerald-50/50 border-emerald-200 p-2 text-xs" data-testid="kb-suggest">
      <div className="eyebrow flex items-center gap-1 text-emerald-800 mb-1"><BookOpenCheck className="h-3 w-3" />Maybe this already answers it</div>
      {rows.map((a) => (
        <div key={a.id} className="flex items-start gap-2 py-0.5" data-testid={`kb-suggest-${a.id}`}>
          <div className="flex-1 min-w-0"><a className="font-medium underline" href={`/app/knowledge?article=${a.id}`} target="_blank" rel="noreferrer">{a.title}</a><div className="text-muted-foreground truncate">{a.snippet}</div></div>
          <button data-testid={`kb-deflect-${a.id}`} className="shrink-0 underline text-emerald-800" onClick={() => deflect(a)}>this solved it</button>
        </div>
      ))}
    </div>
  );
}
